<template>
  <div class="mobile-tips">
    <div class="img-box">
      <img src="@/assets/images/menu/logo.svg" />
    </div>
    <div class="title">{{ $t('common.title') }}</div>
    <div class="tip">{{ $t('common.mobileTips') }}</div>
  </div>
</template>
<script>
import { isMobile } from "@/utils/mobile"

export default {
  created() {
    if (!isMobile()) {
      console.log('在pc打开');
      this.$router.replace({
        name: 'index'
      })
    } else {
      console.log('在m打开');
    }
  }
}
</script>

<style lang="scss">
.mobile-tips {
  .img-box {
    display: flex;
    justify-content: center;
    padding-top: 10%;
    img {
      width: 150px;
      height: 150px;
      display: block;
    }
  }
  
  .title {
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }

  .tip {
    margin-top: 20px;
    font-size: 14px;
    text-align: center;
    padding: 0 8%;
  }
}
</style>

